import { useTranslation } from '@pos/i18n';
import { useBranding } from './branding';
import './Copyright.scss';

/**
 * The copyright line for the footer of a public page: "© <year> <holder>. All rights reserved." The holder is set in
 * branding.json (`copyright`, else the "Powered by" name, else the product name), so no name is written in code.
 * Nothing is shown without one.
 */
export function Copyright({ className, year = new Date().getFullYear() }: { className?: string; year?: number }) {
  const { t } = useTranslation();
  const branding = useBranding();
  const holder = (branding?.copyright ?? branding?.poweredBy?.name ?? branding?.productName)?.trim();
  if (!holder) return null;
  return <p className={className ? `pos-copyright ${className}` : 'pos-copyright'}>{t('common.copyright', { year, holder })}</p>;
}
